import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import api from "@/lib/api";

export default function BlogDetail() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  useEffect(() => { api.get(`/blog/${slug}`).then((r) => setPost(r.data)).catch(() => {}); }, [slug]);
  if (!post) return <div className="p-20 text-center text-hsecondary">Loading...</div>;
  return (
    <div data-testid="blog-detail-page" className="max-w-3xl mx-auto px-6 lg:px-10 py-20">
      <Link to="/blog" className="label-eyebrow text-hgold hover:text-hgold-light">← Back to journal</Link>
      <div className="label-eyebrow text-white/50 mt-8 mb-3">{post.category} · {(post.created_at || "").slice(0,10)}</div>
      <h1 className="text-4xl lg:text-5xl font-heading text-white leading-tight mb-8">{post.title}</h1>
      <img src={post.cover_image} alt="" className="aspect-video object-cover w-full mb-10" />
      <div className="prose prose-invert prose-lg max-w-none text-hsecondary leading-relaxed whitespace-pre-line font-body">
        {post.content}
      </div>
      <div className="mt-16 pt-8 border-t border-white/10 text-white/50 text-sm">— {post.author}</div>
    </div>
  );
}
